import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
import * as Format from "../../common/FormatFunctions";
//Common Functions
import { LoadScreen } from "../Common/LoadScreen";
import * as Feedback from "../../common/Feedback/Feedback";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as log from "../../common/Feedback/Log";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { StatisticViewModel } from "./StatisticViewModel";
import { BPMStatistics } from "../Common/BPMChart";
import { DisplayType } from "../Common/Statistics/ChartObjects";
import { ChartType } from "../Common/Statistics/ChartObjects";
import { ChartsV2 } from "./Chartsv2";
import * as ChartHelper from "./ChartExamples";

import { ChartTypeEnum } from "bpmbuild_developmentappspotcom/src/model/ChartBean";
import { formatDate } from "fullcalendar";

export class Statistics extends Component {
  constructor() {
    super();
    this.state = {
      // LOADING FLAGS
      loaded: false,
      editLoaded: true,

      crudlState: CrudlStatus.LIST,

      statisticSettingsType: "",
      chartSettingsType: "",
      dataSettingsType: "",

      optionSettingsType: "",

      compareSettingsType: "",

      customOptionDateFrom: "",
      customOptionDateTo: "",
      customComparisonDateFrom: "",
      customComparisonDateTo: "",

      productList: [],
      productOptions: [],
      selectedProducts: [],

      chartData: {},
      chartOptions: {},
      chartType: "",
      displayType: DisplayType.CHART,
      statisticsVisible: false
    };

    //SET UP LOGGER AND VIEWMODEL
    this.logger = log;
    this.viewModel = new StatisticViewModel(
      this.updateState,
      this.showError,
      this.showSuccess,
      this.showEmpty
    );
  }

  componentDidMount = () => {
    this.initialDataRender();
  };

  initialDataRender = async () => {
    await this.setPageData();
  };

  setPageData = async () => {
    this.setState({ loaded: false, editLoaded: false });
    await this.viewModel.getProducts();

    this.setState({ loaded: true, editLoaded: true });
  };

  //View Model Link Functions

  showError = (display, crudlStatus) => {
    Feedback.showError(this.growl, display, crudlStatus);
  };
  showSuccess = (display, crudlStatus) => {
    Feedback.showSuccess(this.growl, display, crudlStatus);
  };
  showEmpty = display => {
    Feedback.showEmpty(this.growl, display);
  };
  updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  getStateValuesAsObject = () => {
    var externalObject = {};
    externalObject.statisticBean = this.state.editedStatistic;

    return externalObject;
  };

  parseProductIdList = productList => {
    var productIdList = [];
    if (Format.isNotNull(productList)) {
      productList.forEach(element => {
        productIdList.push(element.id);
      });
    }
    return productIdList;
  };
  getDataForStatisticSelection = async () => {
    var statisticsRequest = {};
    console.log(this.state.selectedProducts);
    statisticsRequest.productList = this.state.selectedProducts;
    statisticsRequest.reportType = this.state.statisticSettingsType;
    statisticsRequest.chartType = this.state.chartSettingsType;
    if (
      this.state.dataSettingsType ===
      CloudService.StatisticsRequest.ComparisonTypeEnum.CUSTOM
    ) {
      statisticsRequest.comparisonType =
        CloudService.StatisticsRequest.ComparisonTypeEnum.CUSTOM;
      statisticsRequest.customComparisonDateFrom = "2019-12-10T16:16:09.506Z";
      statisticsRequest.customComparisonDateTo = "2019-12-20T16:16:09.506Z";
      statisticsRequest.customOptionDateFrom = "2019-12-10T16:16:09.506Z";
      statisticsRequest.customOptionDateTo = "2019-12-20T16:16:09.506Z";
    } else {
      statisticsRequest.optionString = this.state.optionSettingsType;
      statisticsRequest.comparisonType = this.state.dataSettingsType;
      statisticsRequest.comparisonString = this.state.compareSettingsType;
    }

    var response = await this.viewModel.getStatistics(statisticsRequest);
    if (Format.isNotNull(response.statisticsDisplay[0])) {
      var chartDataBean = {};
      chartDataBean.rows = [];
      chartDataBean.columns = [];

      chartDataBean.columns = response.statisticsDisplay[0].chartData.columns;

      chartDataBean.rows = JSON.parse(
        response.statisticsDisplay[0].chartData.rows
      );

      this.logger.info(chartDataBean.rows);
      console.log(chartDataBean.columns);
      console.log(response.statisticsDisplay[0].chartOptions);
      console.log(response.statisticsDisplay[0].chartType);

      this.setState({
        chartData: chartDataBean,
        chartOptions: response.statisticsDisplay[0].chartOptions,
        chartType: "ColumnChart",
        statisticsVisible: true
      });
    }
  };

  onSettingChanged = (value, field) => {
    this.logger.info(value);
    this.updateState(field, value);
  };

  // #endregion

  // #region View
  render() {
    const s = this.state;

    return (
      <div>
        <div
          className="ui-g dashboard"
          style={s.editLoaded === false ? { pointerEvents: "none" } : {}}
        >
          {s.loaded === false ? (
            <LoadScreen />
          ) : (
            <div className="ui-g-12">
              {/*Editing Card*/}

              <div>{this.getEditView()}</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  getEditView = () => {
    return (
      <div>
        <div className="ui-grid ui-fluid">
          <div ref="mainPanel" className="ui-g-12 ui-lg-12">
            <div className="ui-g-12 card-round">
              <div className="ui-g-12 row">
                <div className="ui-g-4 card-cell">
                  <h2 className="title">Statistic</h2>
                  {this.getStatisticSettings()}
                </div>

                <div className="ui-g-4 card-cell">
                  <h2 className="title">Chart</h2>
                  {this.getChartSelector()}
                </div>

                <div className="ui-g-4 card-cell">
                  <h2 className="title">Product</h2>
                  <pr.ListBox
                    value={this.state.selectedProducts}
                    options={this.state.productOptions}
                    onChange={e => this.setState({ selectedProducts: e.value })}
                    multiple={true}
                  />
                </div>
                <div className="ui-g-4 card-cell">
                  <h2 className="title">Type</h2>
                  {this.getDataSettings()}
                </div>
                <div className="ui-g-4 card-cell">
                  <h2 className="title">Options</h2>
                  {this.getDayOptions()}
                  {this.getWeekOptions()}
                  {this.getMonthOptions()}
                  {this.getYearOptions()}
                  {this.getCustomOptions()}
                </div>
                <div className="ui-g-4 card-cell">
                  <h2 className="title">Comparison</h2>
                  {this.getDayComparison()}
                  {this.getWeekComparison()}
                  {this.getMonthComparison()}
                  {this.getYearComparison()}
                  {this.getCustomComparison()}
                </div>
              </div>

              <div className="ui-g-12"></div>
              <pr.Button
                type="button"
                label="Generate"
                className="p-button-success"
                onClick={() => {
                  this.getDataForStatisticSelection();
                }}
                style={{ float: "right", width: "auto" }}
              ></pr.Button>
            </div>
            {this.state.statisticsVisible === true && (
              <React.Fragment>
                <div className="ui-g-12 card-round">
                  <h2 className="title">Chart</h2>
                  <div className="ui-g-12 card">
                    <BPMStatistics
                      displayType={this.state.displayType}
                      chartType={this.state.chartType}
                      chartData={this.state.chartData}
                      chartOptions={this.state.chartOptions}
                      visible={this.state.statisticsVisible}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
          {/* 
          <div className="ui-g-12 ui-lg-3">
            <div className="ui-g-12 card-round">
              <h2 className="title">Summary</h2>
            </div>
          </div> */}
        </div>
      </div>
    );
  };

  getChartSelector = () => {
    return (
      <div className="ui-g-12">
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb1"
            value="AREA"
            onChange={e => {
              this.onSettingChanged(e.value, "chartSettingsType");
            }}
            checked={this.state.chartSettingsType === "AREA"}
          ></pr.Checkbox>
          <label htmlFor="cb1" className="p-checkbox-label">
            Area
          </label>
        </div>
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb2"
            value="BAR"
            onChange={e => {
              this.onSettingChanged(e.value, "chartSettingsType");
            }}
            checked={this.state.chartSettingsType === "BAR"}
          ></pr.Checkbox>
          <label htmlFor="cb2" className="p-checkbox-label">
            Bar
          </label>
        </div>
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb3"
            value="COMBO"
            onChange={e => {
              this.onSettingChanged(e.value, "chartSettingsType");
            }}
            checked={this.state.chartSettingsType === "COMBO"}
          ></pr.Checkbox>
          <label htmlFor="cb3" className="p-checkbox-label">
            Combo
          </label>
        </div>
      </div>
    );
  };

  getStatisticSettings = () => {
    return (
      <div className="ui-g-12">
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb1"
            value={CloudService.StatisticsRequest.ReportTypeEnum.LEADTIME}
            onChange={e => {
              this.onSettingChanged(e.value, "statisticSettingsType");
            }}
            checked={
              this.state.statisticSettingsType ===
              CloudService.StatisticsRequest.ReportTypeEnum.LEADTIME
            }
          ></pr.Checkbox>
          <label htmlFor="cb1" className="p-checkbox-label">
            Lead Time
          </label>
        </div>
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb2"
            value={"CYCLETIME"}
            onChange={e => {
              this.onSettingChanged(e.value, "statisticSettingsType");
            }}
            checked={this.state.statisticSettingsType === "CYCLETIME"}
          ></pr.Checkbox>
          <label htmlFor="cb2" className="p-checkbox-label">
            Cycle Time
          </label>
        </div>
      </div>
    );
  };

  getDataSettings = () => {
    return (
      <div className="ui-g-12">
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb1"
            value={CloudService.StatisticsRequest.ComparisonTypeEnum.DAY}
            onChange={e => {
              this.onSettingChanged(e.value, "dataSettingsType");
            }}
            checked={
              this.state.dataSettingsType ===
              CloudService.StatisticsRequest.ComparisonTypeEnum.DAY
            }
          ></pr.Checkbox>
          <label htmlFor="cb1" className="p-checkbox-label">
            Day
          </label>
        </div>
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb2"
            value={CloudService.StatisticsRequest.ComparisonTypeEnum.WEEK}
            onChange={e => {
              this.onSettingChanged(e.value, "dataSettingsType");
            }}
            checked={
              this.state.dataSettingsType ===
              CloudService.StatisticsRequest.ComparisonTypeEnum.WEEK
            }
          ></pr.Checkbox>
          <label htmlFor="cb2" className="p-checkbox-label">
            Week
          </label>
        </div>
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb3"
            value={CloudService.StatisticsRequest.ComparisonTypeEnum.MONTH}
            onChange={e => {
              this.onSettingChanged(e.value, "dataSettingsType");
            }}
            checked={
              this.state.dataSettingsType ===
              CloudService.StatisticsRequest.ComparisonTypeEnum.MONTH
            }
          ></pr.Checkbox>
          <label htmlFor="cb3" className="p-checkbox-label">
            Month
          </label>
        </div>
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb3"
            value={CloudService.StatisticsRequest.ComparisonTypeEnum.YEAR}
            onChange={e => {
              this.onSettingChanged(e.value, "dataSettingsType");
            }}
            checked={
              this.state.dataSettingsType ===
              CloudService.StatisticsRequest.ComparisonTypeEnum.YEAR
            }
          ></pr.Checkbox>
          <label htmlFor="cb3" className="p-checkbox-label">
            Year
          </label>
        </div>
        <div className="p-col-12">
          <pr.Checkbox
            inputId="cb3"
            value={CloudService.StatisticsRequest.ComparisonTypeEnum.CUSTOM}
            onChange={e => {
              this.onSettingChanged(e.value, "dataSettingsType");
            }}
            checked={
              this.state.dataSettingsType ===
              CloudService.StatisticsRequest.ComparisonTypeEnum.CUSTOM
            }
          ></pr.Checkbox>
          <label htmlFor="cb3" className="p-checkbox-label">
            Custom
          </label>
        </div>
      </div>
    );
  };

  getDayOptions = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.DAY
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb1"
              value={CloudService.StatisticsRequest.OptionStringEnum.TODAY}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.TODAY
              }
            ></pr.Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Today
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={CloudService.StatisticsRequest.OptionStringEnum.YESTERDAY}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.YESTERDAY
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Yesterday
            </label>
          </div>
        </div>
      );
    }
  };
  getWeekOptions = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.WEEK
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb1"
              value={CloudService.StatisticsRequest.OptionStringEnum.lAST7DAYS}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.lAST7DAYS
              }
            ></pr.Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Last 7 Days
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={CloudService.StatisticsRequest.OptionStringEnum.THISWEEK}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.THISWEEK
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              This Week
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={CloudService.StatisticsRequest.OptionStringEnum.LASTWEEK}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.LASTWEEK
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Last Week
            </label>
          </div>
        </div>
      );
    }
  };
  getMonthOptions = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.MONTH
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb1"
              value={CloudService.StatisticsRequest.OptionStringEnum.lAST30DAYS}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.lAST30DAYS
              }
            ></pr.Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Last 30 Days
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={CloudService.StatisticsRequest.OptionStringEnum.THISMONTH}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.THISMONTH
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              This Month
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={CloudService.StatisticsRequest.OptionStringEnum.LASTMONTH}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.LASTMONTH
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Last Month
            </label>
          </div>
        </div>
      );
    }
  };
  getYearOptions = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.YEAR
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb1"
              value={
                CloudService.StatisticsRequest.OptionStringEnum.lAST365DAYS
              }
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.lAST365DAYS
              }
            ></pr.Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Last 365 Days
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={CloudService.StatisticsRequest.OptionStringEnum.THISYEAR}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.THISYEAR
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              This Year
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={CloudService.StatisticsRequest.OptionStringEnum.LASTYEAR}
              onChange={e => {
                this.onSettingChanged(e.value, "optionSettingsType");
              }}
              checked={
                this.state.optionSettingsType ===
                CloudService.StatisticsRequest.OptionStringEnum.LASTYEAR
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Last Year
            </label>
          </div>
        </div>
      );
    }
  };
  getCustomOptions = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.CUSTOM
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <h3>Start Date</h3>
            <pr.Calendar
              value={this.state.customOptionDateFrom}
              onChange={e => this.setState({ customOptionDateFrom: e.value })}
              showTime={true}
              showSeconds={true}
            />
          </div>
          <div className="p-col-12">
            <h3>End Date</h3>
            <pr.Calendar
              value={this.state.customOptionDateTo}
              onChange={e => this.setState({ customOptionDateTo: e.value })}
              showTime={true}
              showSeconds={true}
            />
          </div>
        </div>
      );
    }
  };

  getDayComparison = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.DAY
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb1"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum.PREVIOUSDAY
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum.PREVIOUSDAY
              }
            ></pr.Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Previous Day
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEDAYLASTWEEK
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEDAYLASTWEEK
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Same Day Last Week
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEDAYLASTYEAR
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEDAYLASTYEAR
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Same Day Last Year
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEDAYOFWEEKLASTYEAR
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEDAYOFWEEKLASTYEAR
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Same Day of Week Last Year
            </label>
          </div>
        </div>
      );
    }
  };
  getWeekComparison = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.WEEK
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb1"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .PREVIOUSPERIOD
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .PREVIOUSPERIOD
              }
            ></pr.Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Previous Period
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum.FOURWEEKSAGO
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum.FOURWEEKSAGO
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Four Weeks Ago
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEWEEKLASTYEAR
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEWEEKLASTYEAR
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Same Week Last Year
            </label>
          </div>
        </div>
      );
    }
  };
  getMonthComparison = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.MONTH
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb1"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .PREVIOUSPERIOD
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .PREVIOUSPERIOD
              }
            ></pr.Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Previous Period
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum.FOURWEEKSAGO
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum.FOURWEEKSAGO
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Four Weeks Ago
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEPERIODLASTYEAR
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .SAMEPERIODLASTYEAR
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Same Period Last Year
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .FIFTYTWOWEEKSAGO
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .FIFTYTWOWEEKSAGO
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              52 Weeks Ago
            </label>
          </div>
        </div>
      );
    }
  };
  getYearComparison = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.YEAR
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb1"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum.PREVIOUSYEAR
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum.PREVIOUSYEAR
              }
            ></pr.Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Previous Year
            </label>
          </div>
          <div className="p-col-12">
            <pr.Checkbox
              inputId="cb2"
              value={
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .FIFTYTWOWEEKSAGO
              }
              onChange={e => {
                this.onSettingChanged(e.value, "compareSettingsType");
              }}
              checked={
                this.state.compareSettingsType ===
                CloudService.StatisticsRequest.ComparisonStringEnum
                  .FIFTYTWOWEEKSAGO
              }
            ></pr.Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              52 Weeks Ago
            </label>
          </div>
        </div>
      );
    }
  };
  getCustomComparison = () => {
    if (
      this.state.dataSettingsType !==
      CloudService.StatisticsRequest.ComparisonTypeEnum.CUSTOM
    ) {
      return null;
    } else {
      return (
        <div className="ui-g-12">
          <div className="p-col-12">
            <h3>Start Date</h3>
            <pr.Calendar
              value={this.state.customComparisonDateFrom}
              onChange={e =>
                this.setState({ customComparisonDateFrom: e.value })
              }
              showTime={true}
              showSeconds={true}
            />
          </div>

          <div className="p-col-12">
            <h3>End Date</h3>
            <pr.Calendar
              value={this.state.customComparisonDateTo}
              onChange={e => this.setState({ customComparisonDateTo: e.value })}
              showTime={true}
              showSeconds={true}
            />
          </div>
        </div>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsDashboard.js